/**
 * shutdown-request.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class ShutdownRequest extends ReplyVerifyingMessage
{
    public tag : MessageTag = MessageTag.REQ_SHUTDOWN;
	public static tag : MessageTag = MessageTag.REQ_SHUTDOWN;

    constructor (public shutdown : boolean, public minutes : number)
    {
        super();
    }

    public verifyReply (reply : Message) : boolean
    {
        return Message.isA(reply, MessageTag.RSP_SHUTDOWN);
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/shutdown-request.ts